import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MailService {
  constructor(private http: HttpClient) {}

  sendNotification(e: string, m: string) {
    return this.http.post('https://us-central1-ocean-cdr.cloudfunctions.net/email-notification', {
      email: e,
      content: m,
    });
  }
}
